import { createAsyncThunk } from "@reduxjs/toolkit";
import { api, backendRpc } from "api";
import { ApiError, HttpResponse, NodeLabels } from "api/controlPlaneApi";

export const loadGlobalSitesAsync = createAsyncThunk(
  "system/loadGlobalClusters",
  async (_, { rejectWithValue }) => {
    return backendRpc.api
      .listSites()
      .then((res) => {
        if (res.data !== undefined && res.data.items) {
          return res.data.items!;
        }
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const licenseAsync = createAsyncThunk(
  "system/licenseAsync",
  async (_, { rejectWithValue }) => {
    return api.license
      .license()
      .then((res) => {
        if (res.data) {
          return res.data;
        }
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);

export const getNodeLabelsAsync = createAsyncThunk(
  "system/getNodeLabelsAsync",
  async (siteId: string, { rejectWithValue }) => {
    return api.sites
      .listNodeLabels(siteId!)
      .then((res: HttpResponse<NodeLabels, ApiError>) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err);
      });
  },
);
